module.exports = __webpack_public_path__ + "img/setup-internalignition-min.34d3256c.jpg";